import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { Button, DialogActions, styled } from "@mui/material";
import { ModalWrapper } from "@/components/MediaSelector/MediaTypeTabPanel/ModalWrapper";

import { EditorStoreProvider } from "@/EditorContextProvider";
import { useStore } from "@/Store";
import { StyledDialog } from "@/components/MediaSelector/FocalPointModal";

const ReStyledDialog = styled(StyledDialog)`
  .MuiDialog-paper {
    width: 100%;
    max-width: 600px;
    min-width: unset;
  }
`;
const StyledParagraph = styled("p")`
  padding: 0 16px;
  margin-top: 30px;
  margin-bottom: 0;
`;

export const RestoreDocumentModal: FC = () => {
  const { state, setRestoreDocumentStatus } = useStore();
  const { t } = useTranslation("common");
  const onDeclineRestoration = () => {
    setRestoreDocumentStatus({
      ...state.restoreDocumentStatus,
      restoreDocument: false,
    });
  };
  const onApproveRestoration = () => {
    setRestoreDocumentStatus({
      ...state.restoreDocumentStatus,
      restoreDocument: true,
    });
  };

  return (
    <ReStyledDialog
      maxWidth={"xs"}
      open={state.restoreDocumentStatus.documentToRestore}
      onClose={onDeclineRestoration}
      scroll={"paper"}
    >
      <EditorStoreProvider>
        <ModalWrapper>
          <StyledParagraph>{t("restoreDocument.restoreMessage")}</StyledParagraph>
        </ModalWrapper>
        <DialogActions>
          <Button type="button" color="secondary" variant="outlined" onClick={onDeclineRestoration}>
            {t("restoreDocument.discardChanges")}
          </Button>
          <Button type="button" color="primary" variant="contained" onClick={onApproveRestoration}>
            {t("restoreDocument.applyChanges")}
          </Button>
        </DialogActions>
      </EditorStoreProvider>
    </ReStyledDialog>
  );
};
